module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "informations"
    }
  }, [_c('p', {
    staticClass: "turnMessage"
  }, [_vm._v("La vie a évolué " + _vm._s(_vm.counter) + " fois.")]), _vm._v(" "), _c('p', {
    staticClass: "aliveMessage"
  }, [_vm._v("Nombre de cellules en vie : " + _vm._s(_vm.numberOfAliveCells))]), _vm._v(" "), _c('p', {
    staticClass: "errorMessage"
  }, [_vm._v(_vm._s(_vm.errorMessage))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-89a4553c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Info/Info.vue
// module id = 27
// module chunks = 1